import React from "react"

import { withStyles } from "@material-ui/core"
import contribuinteStyle from "../../assets/css/layout/contribuinteStyle"
import MenuDashboard from "../MenuDashboard"

import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider"
import theme from "../../assets/css/theme"
import { connect } from "react-redux"
import { cadastrosAlvaraTabChanged } from "../../actions"
import Class from "@material-ui/icons/Class"
import List from "@material-ui/icons/List"
import NewReleases from "@material-ui/icons/NewReleases"
import GetApp from "@material-ui/icons/GetApp"
import { bindActionCreators } from "redux"
import TipoAlvara from "./TipoAlvara"
import Alvara from "./Alvara"
import Taxas from "./Taxas"
import DamAlvara from "./DamAlvara"
import AlvaraBaixas from "./AlvaraBaixas"

const tab = [
  {
    name: "Alvará",
    icon: <Class />
  },
  {
    name: "Tipos de Alvará",
    icon: <List />
  },
  {
    name: "Taxas de Alvará",
    icon: <NewReleases />
  },
  {
    name: "Dam's de Alvará",
    icon: <Class />
  },
  {
    name: "Baixas",
    icon: <GetApp />
  }
]

class AlvaraMain extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "",
      error: "",
      pageCount: 0,
      perPage: 0,
      page: 1,
      contribuintes: [],
      field: 0,
      refAlvara: null
    }
    this.handleFieldChange = this.handleFieldChange.bind(this)
  }

  handlePageClick(data) { }

  handleChange = event => {
    this.setState({ value: event.target.value })
  }

  handleChangePage = (event, page) => {
    if ((page || 1) !== this.state.page) {
      this.setState({ page }, () => { this.getData(this.state.page) })
    }
  }

  handleFieldChange(value) {
    this.props.cadastrosAlvaraTabChanged(value)
  }

  render() {
    const { classes, field } = this.props
    return (
      <div className={classes.container}>
        <MuiThemeProvider theme={theme}>
          <MenuDashboard
            names={tab}
            onChange={this.handleFieldChange}
            value={field}
          />
          {field === 0 && <Alvara />}
          {field === 1 && <TipoAlvara />}
          {field === 2 && <Taxas />}
          {field === 3 && <DamAlvara />}
          {field === 4 && <AlvaraBaixas />}
        </MuiThemeProvider>
      </div>
    )
  }
}
function mapStateToProps(state) {
  return {
    field: state.tabLayout.cadastrosAlvaraTabSelected
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ cadastrosAlvaraTabChanged }, dispatch)
}
AlvaraMain = connect(
  mapStateToProps,
  mapDispatchToProps
)(AlvaraMain)
export default withStyles(contribuinteStyle)(AlvaraMain)
